class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Close cart drawer on Escape key or overlay click
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));

    // Set up accessibility for cart icons
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const setupCartIcon = (cartIcon) => {
      cartIcon.setAttribute('role', 'button');
      cartIcon.setAttribute('aria-haspopup', 'dialog');
      cartIcon.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartIcon);
      });
      cartIcon.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartIcon);
        }
      });
    };

    const cartLink = document.querySelector('#cart-icon-bubble');
    const cartLink_2 = document.querySelector('#cart-icon-bubble-1');
    if (cartLink) setupCartIcon(cartLink);
    if (cartLink_2) setupCartIcon(cartLink_2);
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    // Update progress bar after rendering contents
    this.updateProgressBar(parsedState);
    
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Function to update the progress bar
  updateProgressBar(cart) {
    const freeShippingThreshold = 10000; // Adjust this value as per your logic
    const progress = (cart.total_price / freeShippingThreshold) * 100;
    
    // Update the progress bar width
    const progressBarFill = document.querySelector('.cart-progress__fill');
    if (progressBarFill) {
      progressBarFill.style.width = `${progress}%`;
    }

    // Update the status message
    const statusMessage = cart.total_price < freeShippingThreshold
      ? `You are ${Shopify.formatMoney(freeShippingThreshold - cart.total_price)} away from free shipping!`
      : 'Congratulations! You have earned free shipping!';
    
    const statusElement = document.querySelector('.cart-progress__status');
    if (statusElement) {
      statusElement.innerText = statusMessage;
    }
  }

  initializeHorizontalScroll() {
    const scrollContainer = document.querySelector('.scroll-container');
    if (scrollContainer) {
      // Enable smooth scrolling
      scrollContainer.style.scrollBehavior = 'smooth';
    }
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.initializeHorizontalScroll();
  }
});
